module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/Prizes/merchandise-d2ab26901a71b51557067c7755b28725.svg";